<script lang="ts">
	interface Props {
		checked?: boolean;
		disabled?: boolean;
		id?: string;
		name?: string;
		ontoggle?: (checked: boolean) => void;
	}

	let {
		checked = $bindable(false),
		disabled = false,
		id = '',
		name = '',
		ontoggle
	}: Props = $props();
</script>

<!-- A styled native checkbox, matching the Aqueduct toggles (GraphSettings
     .profile-toggle) in size, appearance, and mechanics: the browser handles
     the tap, so there is nothing to intercept it on touch devices. -->
<input
	type="checkbox"
	{id}
	{name}
	{disabled}
	class="toggle"
	aria-label={name || 'Toggle'}
	{checked}
	onchange={(e) => {
		checked = e.currentTarget.checked;
		ontoggle?.(checked);
	}}
/>

<style>
	.toggle {
		width: 34px;
		height: 18px;
		appearance: none;
		border-radius: 999px;
		border: 1px solid var(--toggle-border, #d6d4c6);
		background: var(--toggle-background, #e4e4e7);
		position: relative;
		cursor: pointer;
	}
	.toggle::after {
		content: '';
		position: absolute;
		top: 2px;
		left: 2px;
		width: 12px;
		height: 12px;
		border-radius: 999px;
		background: #ffffff;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
	}
	.toggle:checked {
		background: var(--toggle-checked-background, #0891b2);
		border-color: var(--toggle-checked-border, #0891b2);
	}
	.toggle:checked::after {
		transform: translateX(16px);
	}
	:global(.dark) .toggle {
		background: var(--toggle-background, #27272a);
		border-color: var(--toggle-border, #2a2a32);
	}
	:global(.dark) .toggle:checked {
		background: var(--toggle-checked-background, #06b6d4);
		border-color: var(--toggle-checked-border, #06b6d4);
	}
	.toggle:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
</style>
